revogr-scroll-virtual {
  $min-size: 20px;

  // show scroll only for 1 sec
  &[autohide] {
    position: absolute;
    z-index: 100 !important;

    &.vertical {
      top: 0;
      right: 0;

      &[visible] {
        min-width: $min-size !important;
      }
    }

    &.horizontal {
      bottom: 0;
      left: 0;

      &[visible] {
        min-height: $min-size !important;
      }
    }
  }

  &.vertical {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    > div {
      width: 1px;
    }
  }

  &.horizontal {
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;

    > div {
      height: 1px;
    }
  }
}
